var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"echartsGroup"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isReturnChina),expression:"isReturnChina"}],staticClass:"button",on:{"click":function($event){return _vm.returnChinaFn()}}},[_vm._v("返回中国地图")]),_c('div',{ref:"china_map",staticStyle:{"height":"450px","width":"800px"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }